import { EVENT } from "@/lib/eventData";
import { Frangipani } from "@/components/gala/TropicalDecor";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#082017]/70 backdrop-blur border-t border-[#D4AF37]/25 pt-16 pb-10 overflow-hidden"
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <Frangipani className="absolute -top-10 right-8 w-60 text-[#D9C7A0]/10 rotate-12" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="relative w-9 h-9 grid place-items-center border border-[#D4AF37]/70 rotate-45">
                <span className="w-4 h-4 bg-[#D4AF37]/90 -rotate-45" />
              </span>
              <span className="font-display text-[#F3E08A] tracking-[0.35em] text-sm">
                HAVANA
              </span>
            </div>
            <p className="font-serif-luxe italic text-[#E0D5B8] text-sm leading-relaxed max-w-sm">
              A once-in-a-year celebration of our people, our wins and the
              music of the tropics.
            </p>
          </div>

          <div>
            <div className="font-display text-[10px] tracking-[0.35em] text-[#9F7E30] mb-4">
              — When & Where
            </div>
            <div className="space-y-1 text-sm">
              <div className="text-[#F8F1DC]">{EVENT.date}</div>
              <div className="text-[#E0D5B8]">{EVENT.time}</div>
              <div className="text-[#E0D5B8]">{EVENT.venue}</div>
              <div className="text-[#A5BCB1] text-xs">{EVENT.address}</div>
            </div>
          </div>

          <div>
            <div className="font-display text-[10px] tracking-[0.35em] text-[#9F7E30] mb-4">
              — Kind Reminders
            </div>
            <ul className="space-y-2 text-sm text-[#E0D5B8]">
              <li>RSVPs kindly requested by October 19</li>
            </ul>
          </div>
        </div>

        <div className="hairline-gold mb-6" />
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-[#A5BCB1]">
          <div>© 2026 Havana Nights · Curated with rum, rhythm & reverence.</div>
          <div className="font-display tracking-[0.3em]">
            HASTA LA NOCHE
          </div>
        </div>
      </div>
    </footer>
  );
}
